import React, { useState } from 'react';
import { Card, Col, Row } from 'antd';
import { Link, useParams } from 'react-router-dom';
import isObject from 'lodash/isObject';
import { useIntl } from 'react-intl';
import IntlMessages from '../../../../../layout/components/lang/IntlMessages';
import BreadCrumbs from '../../../../../layout/components/breadcrumbs';
import urlPageRBACRoles from '../../../../../urls/urlPageRBACRoles';
import FormCreateEditRole from '../../../forms/FormCreateEditRole';
import handleResponse from '../../../../../lib/handleResponse';
import FormEditPermissions from '../../../forms/FormEditPermissions';
import useToggle from '../../../../../app/hooks/useToggle';
import { useGetPermissionsQuery } from '../../../api/permissionsApiSlice';
import { HasRights } from '../../../../../components/HasRights/HasRights';
import { Permissions } from '../../../../../const/permissions';
import {
  useGetRolePermissionsQuery,
  useGetRoleQuery,
  useUpdateRoleMutation,
  useUpdateRolePermissionsMutation,
} from '../../../api/rolesApiSlice';



const PageRoleDetails = () => {
  const intl = useIntl();
  const { roleId } = useParams();
  const [ isActiveFormEditRole, toggleEditRoleActive ] = useToggle();
  const [ isActiveEditPermissionsForm, toggleEditPermissionsActive ] = useToggle();
  const [ roleDetailsErrors, setCreateRoleDetailsErrors ] = useState({});
  const [ rolePermissionsErrors, setCreateRolePermissionsErrors ] = useState({});

  const { data: rolesDetails = {}, isLoading } = useGetRoleQuery(roleId);

  const { data: { data: permissionsList = [] } = { data: [], pagination: {} },
    isFetching: isLoadingPermissionsList,
  } = useGetPermissionsQuery({ queryParams: 'limit=0' });

  const { data: rolePermissions = [], isLoading: isLoadingRolePermissionsList } = useGetRolePermissionsQuery(roleId);
  const [ updateRole, { isLoading: isLoadingUpdateRole } ] = useUpdateRoleMutation();
  const [ updateRolePermissions, { isLoading: isLoadingUpdateRolePermissions } ] = useUpdateRolePermissionsMutation();

  const rolePermissionsIds = rolePermissions?.map((item) => item.id);

  const handleSubmitUpdateRoleForm = async (values) => {
    updateRole({ values, roleId })
      .unwrap()
      .then(() => handleResponse(
        'success',
        intl,
        'ui-general-updated-successfully',
        [ toggleEditRoleActive ],
      ))
      .catch((error) => handleResponse(
        'error',
        intl,
        'ui-general-update-failed',
        [ () => {
          if (isObject(error?.data?.errors)) {
            setCreateRoleDetailsErrors(error.data.errors);
          }
        } ],
        error,
      ));
  };

  const handleSubmitFormEditPermissions = async (values) => {
    updateRolePermissions({ values, roleId })
      .unwrap()
      .then(() => handleResponse(
        'success',
        intl,
        'ui-general-updated-successfully',
        [
          toggleEditPermissionsActive,
        ],
      ))
      .catch((error) => handleResponse(
        'error',
        intl,
        'ui-general-update-failed',
        [ () => {
          if (isObject(error?.data?.errors)) {
            setCreateRolePermissionsErrors(error.data.errors);
          }
        } ],
        error,
      ));
  };

  const handleSetRoleDetailsEdit = () => {
    toggleEditRoleActive();
    setCreateRoleDetailsErrors({});
  };


  const handleSetRolePermissionsEdit = () => {
    toggleEditPermissionsActive();
    setCreateRolePermissionsErrors({});
  };

  return (
    <>
      <Row gutter={32}>
        <Col className="hp-mb-32" span={24}>
          <BreadCrumbs
            breadCrumbParent={
              <Link to={urlPageRBACRoles()}>
                <IntlMessages id='roles-breadcrumbs' />
              </Link>
            }
            breadCrumbActive={<IntlMessages id='role-details-breadcrumbs' />}
          />
        </Col>
      </Row>

      {HasRights([ Permissions.ADMINISTRATION.ROLES.ROLE_DETAILS.VIEW ]) && (
        <Row gutter={[ 16, 16 ]}>
          <Col md={12} span={24} className="hp-profile-content-list hp-mt-32 hp-ml-24 hp-pb-sm-0 hp-pb-120">
            <Card
              title={<IntlMessages id="role-details-card-header" />}
              loading={isLoadingUpdateRole || isLoading}
              style={{ marginBottom: '10px' }}
            >
              <FormCreateEditRole
                initialValues={rolesDetails}
                formErrors={roleDetailsErrors}
                isRoleEdit
                handleSetFormEdit={handleSetRoleDetailsEdit}
                isEditDisabled={!isActiveFormEditRole}
                onSubmit={handleSubmitUpdateRoleForm}
                isSubmitting={isLoadingUpdateRole}
              />
            </Card>
          </Col>

          <Col md={12} span={24} className="hp-profile-content-list hp-mt-32 hp-ml-24 hp-pb-sm-0 hp-pb-120">
            <Card
              title={<IntlMessages id="role-permissions-card-header" />}
              loading={isLoadingUpdateRolePermissions || isLoadingPermissionsList || isLoadingRolePermissionsList}
              style={{ marginBottom: '10px' }}
            >
              <FormEditPermissions
                initialValues={{ permissions_ids: rolePermissionsIds }}
                formErrors={rolePermissionsErrors}
                permissionsOptions={permissionsList}
                onSubmit={handleSubmitFormEditPermissions}
                isSubmitting={isLoadingUpdateRolePermissions}
                handleSetFormEdit={handleSetRolePermissionsEdit}
                isDisabled={!isActiveEditPermissionsForm}
              />
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default PageRoleDetails;
